import axios from 'axios';
import backendUrl from '../backendUrl';

export let token: string | null = null;

const setToken = (newToken: string | null): void => {
  token = newToken;
};

const login = async (credentials: any): Promise<any> => {
  const response = await axios.post(`${backendUrl}/api/login`, credentials);
  return response.data;
};

const signup = async (enteredData: any): Promise<any> => {
  const response = await axios.post(`${backendUrl}/api/signup`, enteredData);
  return response.data;
};

const authService = { setToken, login, signup };

export default authService;
